import { dataMapRef } from './consts';
import { fieldTraitProgressBarOptions, fieldTraitTextContentOptions } from '../dataGroup/traitsApi';
import { getCollectionFields } from '../pluginComponentApi';
export default function (editor, opts = {}) {
  const { projectId, collections, labelMap, labelColName, labelFinderName } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(dataMapRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': labelMap,
          icon: '<i class="wb webconnect-google-maps"></i><div>',
          collectionName: '',
          projectId: projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          script: function () {
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';
            const zoomValue = '{[ data-map-zoom ]}';
            loadDataMapItems(finderId, collectionId, zoomValue, this);
          },
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });
          this.addTrait([
            {
              type: 'select',
              label: labelColName,
              name: 'collectionName',
              changeProp: 1,
              options: options,
            },
            {
              type: 'select',
              label: labelFinderName,
              name: 'finderUuid',
              changeProp: 1,
            },
          ]);
          if (collectionName) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            const finderOptions = selectedCollection
              ? selectedCollection.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            this.getTrait('finderUuid').set({ options: finderOptions });
          }
          this.on('change:collectionName', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collectionResponse = await getCollectionFields(collectionName, collections);
          this.setAttributes({
            selectedCollectionData: collectionResponse,
          });
          if (collectionResponse) {
            const finderOptions = [];
            collectionResponse.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            this.removeTrait('data-map-lat');
            this.removeTrait('data-map-long');
            this.removeTrait('data-map-header');
            this.removeTrait('data-map-description');
            this.removeTrait('data-map-zoom');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collectionResponse);
            const fieldTraitsOptions = await fieldTraitTextContentOptions(
              collectionResponse,
              collections,
            );
            this.addTrait({
              name: 'data-map-lat',
              label: 'Latitude',
              options: numberFieldTraitsOptions,
              title: `latitude`,
              type: 'data-map-trait',
            });
            this.addTrait({
              name: 'data-map-long',
              label: 'Longitude',
              options: numberFieldTraitsOptions,
              title: `longitude`,
              type: 'data-map-trait',
            });
            this.addTrait({
              name: 'data-map-header',
              label: 'Header',
              options: fieldTraitsOptions,
              title: `header`,
              type: 'data-map-trait',
            });
            this.addTrait({
              name: 'data-map-description',
              label: 'Description',
              options: fieldTraitsOptions,
              title: `description`,
              type: 'data-map-trait',
            });
            this.addTrait({
              name: 'data-map-zoom',
              label: 'Zoom',
              type: 'range',
              min: '1',
              max: '14',
              changeProp: 1,
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'data-map') {
            return {
              type: 'data-map',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:data-map-zoom', this.updateScript);
      },
    }),
  });
}
